module.exports = __webpack_public_path__ + "static/media/TRIAL 1 if-both-wrong.29814d17.mp3";